import { useMemo, useRef, useEffect, useState } from "react";
import DataTableWrapper from '../../../Components/CommonTableLayout/DataTableWrapper';
import { fetchCurrencyConversion } from "../../../services/CurrencyConversion/currencyConversion";
import { Link } from "react-router-dom";



const CurrencyConverterTable = ({ filters, setRowCount }) => {
  const gridRef = useRef();
  const [rows, setRows] = useState([]);

  const columns = useMemo(() => [
     {
            field: 'currencyFrom',
            headerName: 'Currency From',
            cellRenderer: (params) => {
                return (
                    <Link
                        to={ `conversion-detail/${params.value}` }
                        state={ params.data }
                        style={ {
                            color: "#1976d2",
                            textDecoration: "underline",
                            cursor: "pointer",
                        } }
                    >
                        { params.value }
                    </Link>

                );
            }
            , width: 200
    },
    { field: 'currencyTo', headerName: 'Currency To', width: 250 },
    { field: 'currentMonthlyFxRate', headerName: 'Monthly Exchange Rate', width: 250 },
    { field: 'currentYearlyFxRate', headerName: 'Yearly Exchange Rate', width: 250 },
    { field: 'lmd', headerName: 'LMD', width: 250 },
  ], []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Call your service (pass itemNo and siteCode if needed)
        const data = await fetchCurrencyConversion();
     
        setRows(data || []);
        if (setRowCount) setRowCount( data?.length || 0);
      } catch {
        setRows([]);
        if (setRowCount) setRowCount(0);
      }
    };
    fetchData();
  }, [filters, setRowCount]);

  return (
    <DataTableWrapper
      title="Currency Conversion"
      rows={rows}
      columns={columns}
      filters={filters}
      height={500}
    />
  );
};

export default CurrencyConverterTable;